/**
 * Scrolls the first visible error message into view after a failed validation
 * attempt. Must be called after trigger() resolves, but wrapped in
 * requestAnimationFrame so React has flushed the error state to the DOM first.
 */
export const scrollToFirstError = () => {
  requestAnimationFrame(() => {
    document
      .querySelector<HTMLElement>('[data-testid="error-message"]')
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
};
